import React, { useRef } from "react";
import { View } from "react-native";
import SignatureScreen from "react-native-signature-canvas";
import { Link } from "../../../Link/Link";
import { styles } from "./InputSignature.styles";
/**
 * Scrolling of the screen must be disabled when using this component:
 * set the scrollEnabled prop of the Screen component inside the parent, i.e. <Screen scrollEnabled={scrollEnabled}>
 * Use the useState hook inside the parent component: const [scrollEnabled, setScrollEnabled] = useState(true);
 * then pass the setter to InputSignature, <Input.Signature setScrollEnabled={setScrollEnabled} />
 */
export const InputSignature = ({ onChange, setScrollEnabled, height = 300, buttonColour = "greyscale", buttonText = "Clear", onConfirm, ...rest }) => {
    const ref = useRef(null);
    const handleSignature = (signature) => {
        onChange?.(signature);
    };
    const handleClear = () => {
        ref.current?.clearSignature();
        onChange?.("");
    };
    const handleBegin = () => {
        setScrollEnabled?.(false);
        ref.current?.draw();
    };
    const handleEnd = () => {
        setScrollEnabled?.(true);
        ref.current?.readSignature();
    };
    return (React.createElement(View, { renderToHardwareTextureAndroid: true, testID: `${rest.name}SignatureInput` },
        React.createElement(SignatureScreen, { ref: ref, onEnd: handleEnd, onOK: handleSignature, onBegin: handleBegin, onGetData: onConfirm, style: [styles.input, { height }], androidHardwareAccelerationDisabled: true }),
        React.createElement(View, { style: styles.clearButtonContainer },
            React.createElement(Link, { onPress: handleClear, color: buttonColour }, buttonText))));
};
//# sourceMappingURL=InputSignature.js.map